<template>
  <div class="content">

    <div class="d-flex justify-content-end align-items-center d-flex-grap mb-2">
      <b-button id="show-btn" @click="onHandleOpenModalToCreateNewDetail()" variant="primary"><i
          class="fa fa-plus mr-1"></i> Agregar</b-button>
    </div>

    <b-table :bordered="true" :borderless="true" :outlined="true" :hover="true" :fixed="true" :no-border-collapse="true"
      table-variant="white" :fields="tableConfig.fields" :items="responseGuidesOfEmergencies.data"
      :busy="loadingDataTable" responsive>

      <!-- Columna naciones unidas -->
      <template #cell(nu)="data">
        {{ data.item.codigo_un }}
      </template>

      <!-- Columna gre. -->
      <template #cell(gre)="data">
        {{ data.item.gre }}
      </template>

      <!-- Columna Nombre del material -->
      <template #cell(material_name)="data">
        {{ data.item.peligro_un }}
      </template>
      
      <!-- Columna acciones -->
      <template #cell(actions)="data">
        <el-tooltip class="ml-2" content="Ver detalles" placement="bottom" effect="light">
          <b-button type="text" size="sm" variant="outline-primary" @click="onHandleOpenDetails(data.item.id)">
            <i class="fa fa-list mr-1" />
            Ver detalles
          </b-button>
        </el-tooltip>
      </template>

    </b-table>

    <!-- Validaciones e información -->
    <div>
      <div v-if="tableConfig.dataFields.total <= 0 && !loadingDataTable" class="text-center w-100 p-4">
        <div class="text-center">
          <i class="d-block fa fa-tasks mr-1 icon-list-empty"></i>
          <small>No hay datos para mostrar...</small>
        </div>
      </div>
    </div>

    <!-- Paginación -->
    <div>
      <div class="d-flex justify-content-end align-items-center pr-4 mt-4">

        <el-pagination :total="tableConfig.dataFields.total" v-model="tableConfig.dataFields.page"
          :current-page="tableConfig.dataFields.page" :page-sizes="[10, 20, 30, 100]"
          :page-size="tableConfig.dataFields.per_page" layout="total, sizes, prev, pager, next"
          @size-change="loadAfterChangeSizePagination" @current-change="loadAfterChangePagePagination" />

      </div>
      <br />
    </div>

    <!-- Modal para Ver detalles del NU - GRE -->
    <DetailsNuGreComponent />

    <!-- Modal para crear/editar -->
    <b-modal id="bv-modal-manage-config-nu-gres" hide-footer>
      <template #modal-title>
        {{ action === 'EDIT' ? 'Editar' : 'Crear' }} guía de respuestas a emergencias
      </template>

      <ConfigNuGreFormComponent />
    </b-modal>

  </div>
</template>

<script>

// Importaciones generales
import { mapState, mapActions, mapMutations } from "vuex";

// Componentes
import DetailsNuGreComponent from './Details.vue'
import ConfigNuGreFormComponent from './Form.vue'

export default {
  name: "ConfigNuGreComponent",
  components: {
    DetailsNuGreComponent,
    ConfigNuGreFormComponent
  },
  computed: {
    // Estados para el modulo del Naciones unidas - gre
    ...mapState("NuGreAdmin", [
      'responseGuidesOfEmergencies',
      'tableConfig',
      'action'
    ]),
    // Estados para el modulo del Dashboard
    ...mapState('dashboard', {
      loadingDataTable: 'loading'
    }),
    // Estados para el modulo del Naciones unidas - gre: configurar respuestas de guías de emergencias
    ...mapState('NuGreCustomFields', [
      'customFields'
    ]),
  },
  methods: {
    // Acciones para el modulo del Naciones unidas - gre administración
    ...mapActions("NuGreAdmin", ['getEmergencyResponseGuides', 'getDetailsByEmergencyResponseGuide']),
    // Acciones para el modulo del Naciones unidas - gre administración
    ...mapMutations("NuGreAdmin", [
      'setTableConfigPagination',
      'setCurrentNuGreActive',
      'resetDetailsNuGres',
      'setAction',
      'setUseSelectNuGreInFrom'
    ]),
    /**
     * Cambiar la cantidad de ítems por página en la paginación.
     * 
     * @author Fernando Claros
     */
    async loadAfterChangeSizePagination(per_page = 10) {
      this.setTableConfigPaginationNuGre({ ...this.tableConfig.dataFields, per_page, page: 1 });
      await this.getEmergencyResponseGuides({ page: this.tableConfig.dataFields.page, per_page: this.tableConfig.dataFields.per_page });
    },
    /**
     * Cambiar entre páginas en la paginación.
     * 
     * @author Fernando Claros
     */
    async loadAfterChangePagePagination(page = 1) {
      this.setTableConfigPaginationNuGre({ ...this.tableConfig.dataFields, page });
      await this.getEmergencyResponseGuides({ page: this.tableConfig.dataFields.page, per_page: this.tableConfig.dataFields.per_page });
    },
    /**
     * Abrir modal para ver detalles.
     * 
     * Se cargan los campos personalizados con sus valores para el ítem de NU - GRE actual.
     * 
     * @author Fernando Claros
     */
    onHandleOpenDetails(id) {
      this.getDetailsByEmergencyResponseGuide({

        id,
        page: this.tableConfig.dataFieldsDetails.page,
        per_page: this.tableConfig.dataFieldsDetails.per_page

      }).then(() => {
        this.setCurrentNuGreActive(id);
        this.$bvModal.show('bv-modal-details-nu-gres')
      }).catch(() => this.setCurrentNuGreActive(null))
    },
    /**
     * Abrir modal para crear nuevos detalles a un NU - GRE.
     * @author Fernando Claros
     */
    onHandleOpenModalToCreateNewDetail() {
      this.resetDetailsNuGres();
      this.setAction('CREATE');
      this.setUseSelectNuGreInFrom(true);
      this.$bvModal.show('bv-modal-manage-config-nu-gres')
    }
  }
};
</script>

<style scoped>
.icon-list-empty {
  font-size: 40px;
}
.content {
  max-width: 100%;
  overflow-x: auto;
  min-width: 400px;
}
</style>
